import { RegionShared } from "@1games-ru/region-shared";
import { useState } from "react";
import FocusLock from "react-focus-lock";
import { TfaMethod } from "@/core/constants/tfaMethod";
import { callServer } from "@/core/helpers/callEvent.ts";
import useAppDispatch from "@/core/helpers/useAppDispatch.ts";
import useAppSelector from "@/core/helpers/useAppSelector";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { ValidateCode } from "@/shared/ui";
import { setEmailConfirmed, setSignUp, sighUpSelector } from "@/domains/auth/slice";
import useGetSocialClub from "@/domains/auth/hooks/useGetSocialClub";
import AuthTitle from "@/domains/auth/components/AuthTitle";

export default function AuthSignUpConfirmEmailContainer() {
  const tError = useErrorTranslation();
  const dispatch = useAppDispatch();
  const [pending, setPending] = useState<boolean>(false);
  const [sendCodePending, setSendCodePending] = useState<boolean>(false);
  const [code, setCode] = useState<string>("");
  const [error, setError] = useState<string | undefined>();
  const signUp = useAppSelector(sighUpSelector);
  const { getSocialClub } = useGetSocialClub();

  const onSubmit = (): void => {
    if (pending) return;
    setPending(true);
    setError("");
    callServer(RegionShared.Backend.Events.Auth.FinishRegister, { code })
      .then(() => {
        dispatch(setEmailConfirmed(true));
      })
      .catch(({ message }) => {
        setCode("");
        setError(tError(message));
      })
      .finally(() => {
        setPending(false);
      });
  };
  const onSendCode = (): void => {
    if (sendCodePending) return;
    setSendCodePending(true);
    callServer(RegionShared.Backend.Events.Auth.StartRegister, signUp)
      .then(() => {
        getSocialClub();
      })
      .catch(({ message }) => {
        setError(tError(message));
      })
      .finally(() => {
        setSendCodePending(false);
      });
  };

  return (
    <>
      <AuthTitle
        back={() => {
          dispatch(
            setSignUp({
              email: "",
              password: "",
              promoCode: "",
            }),
          );
        }}
      >
        {tError("ENTER_VERIFICATION_CODE")}
      </AuthTitle>
      <FocusLock className="contents">
        <ValidateCode
          address={signUp.email}
          type={TfaMethod.EMAIL}
          code={code}
          onCodeChange={setCode}
          onSubmit={onSubmit}
          onSendCode={onSendCode}
          pending={pending}
          sendCodePending={sendCodePending}
          error={error}
        />
      </FocusLock>
    </>
  );
}
